import { useContext } from "react";
import { ToastContext } from "../components/common/ToastProvider";

/**
 * useToast — tiny toast dispatcher.
 *
 *   const toast = useToast();
 *   toast.success("Saved!");
 *   toast.error("Could not load users");
 *   toast.info("Polling stopped");
 */
export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error("useToast must be used inside <ToastProvider>");
  }
  return ctx;
}
